import React from 'react';
import { ItemForm } from '../../Components/Form';
import FormLayout from '../../Components/Layout/FormLayout';
import { NewItemIcon } from '../../Assets/Navigation/NavigationIcons';
import { t } from 'i18next';

const CloneItem = ({ handleToast, ...props }) => {
  document.title = 'Clone Item';

  return (
    <FormLayout
      title={t('Items.items')}
      Icon={NewItemIcon}
      subtitle={t('common.clone')}
      closeUrl="/items"
      iconstyle="general_module_icon"
      layoutBoxClass="uiux-form-redesign"
    >
      <ItemForm
        type="clone"
        id={props.match.params.id}
        handleToast={handleToast}
      />
    </FormLayout>
  );
};

export default CloneItem;
